<template>
    <component :is="'div'" style="height: 100%">
        <slot
            :is-white-labeled="isWhiteLabeled"
            :contact="contact"
            :is-loading="isLoading"
            :send-verification-email="sendVerificationEmail"
            :skip-verification="skipVerification"
        />
    </component>
</template>

<script>
    import WhiteLabelingMixin from '../mixins/WhiteLabelingMixin';
    import BaseProviderMixin from '../mixins/BaseProviderMixin';
    import ContactsMixin from '../mixins/ContactsMixin';
    import EventTrackingMixin from './../../../mixins/EventTrackingMixin';
    import NetworkConnectionMixin from '../../../mixins/NetworkConnectionMixin';
    import { message } from '@grininc/grin-ui';

    export default {
        name: 'AccountVerificationProvider',
        mixins: [WhiteLabelingMixin, BaseProviderMixin, ContactsMixin, NetworkConnectionMixin, EventTrackingMixin],
        computed: {
            emailVerificationUrl() {
                return `/contact/${this.contactId}/login/verification`;
            },
            profilePageUrl() {
                return `/${this.liveId}/profile`;
            }
        },
        methods: {
            sendVerificationEmail() {
                const subdomain = window.location.hostname.split('.')[0];
                this.$http
                    .post(this.emailVerificationUrl, { subdomain })
                    .then(() => {
                        message.success('Email Sent!');
                        this.trackEventAccountVerificationStarted('email');
                        this.$router.push({ name: 'v2.account.verify.email.sent' });
                    })
                    .catch(() => {
                        message.error('Whoops! We could not send you an email, please reach out to support');
                    });
            },
            skipVerification() {
                window.location.href = `/${this.liveId}`;
            }
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .catch((error) => this.handleHttpError(error))
                .then(() => (this.isLoading = false));
        }
    };
</script>
